import { PropTypes } from 'react';

export const ArticlePropTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/constants/PropTypes.js
 **/